import { createContext, useContext } from 'react';

export const HOME_READY_STEPS = [
  'home-mounted',
  'home-first-paint',
  'hero-media-ready',
  'hero-scroll-ready',
] as const;

export type HomeReadyStep = (typeof HOME_READY_STEPS)[number];

interface HomeReadyContextValue {
  markStepReady: (step: HomeReadyStep, ready?: boolean) => void;
}

const noop = () => undefined;

const HomeReadyContext = createContext<HomeReadyContextValue>({
  markStepReady: noop,
});

export const HomeReadyProvider = HomeReadyContext.Provider;

export const useHomeReady = () => useContext(HomeReadyContext);
